import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom'
import logo from '../assets/logotipo.png'
import background from '../assets/background_frutas.png'
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { signup, getDoencas, getNutrientes, createDiagnostico } from '../service/api';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import './Cadastro.scss';

const Cadastro = () => {
    let navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [nome, setNome] = useState("")
    const [sobrenome, setSobrenome] = useState("")
    const [password, setPassword] = useState("")
    const [altura, setAltura] = useState("")
    const [peso, setPeso] = useState("")
    const [open, setOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [data, setData] = useState('');
    const [born, setBorn] = useState("");
    const [page, setPage] = useState(1)
    const [doeancasList, setDoeancasList] = useState([])
    const [doenca, setDoenca] = useState({});
    const [description, setDescription] = useState('');
    const [nutrientesList, setNutrientesList] = useState([])
    const [recConsumoDiario, setRecConsumoDiario] = useState({});
    const [viewDescription, setViewDescription] = useState(false);

    const handleChangeDate = (newValue) => {
        const month = newValue.$d.getMonth() + 1
        const newDate = newValue.$y + "-" + month + "-" + newValue.$D
        setData(newValue)
        setBorn(newDate)
    }

    const onClickLogin = (path) => {

        navigate(path, { replace: true })
    }

    const fullDescription = () => setViewDescription(!viewDescription)

    const onClickSignup = async (path) => {
        await signup(nome, sobrenome, email, password, altura, peso, born)
            .then(async response => {
                console.log(response)
                if (response) {
                    localStorage.setItem("userId", response.userId)
                    await saveDoenca(response.userId, path)
                }
            })
            .catch(function (error) {
                console.log(error)
                setErrorMessage("Erro no cadastro")
                setOpen(true)
            });
    }

    const nextPage = (pageNumber) => {
        loadDoencas()
        setPage(pageNumber)
    }

    const handleChangeRecomendacao = (value, item) => {
        let recs = recConsumoDiario
        recs[item.nutrienteid] = value
        console.log(recs)
        setRecConsumoDiario(recs)
    };

    const handleChange = (value, state) => {
        state(value)
    }

    const handleChangeSelect = (event) => {
        setDoenca(event.target.value);
        setDescription(event.target.value.descricao)
        loadNutrientes(event.target.value.doencaid)
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const saveDoenca = async (userId, path) => {
        let doencaData = {
            'doencaId': doenca.doencaid,
            'nome': doenca.nome
        }
        console.log(doencaData)
        if (doenca.doencaid) {
            let error = false
            var nutrientesData = nutrientesList.map(function (item, i) {
                if (!recConsumoDiario[item.nutrienteid]) {
                    return {
                        'nutrienteid': item.nutrienteid,
                        'quantidade': 0,
                        'nome': item.nome
                    }
                } else {
                    return {
                        'nutrienteid': item.nutrienteid,
                        'quantidade': recConsumoDiario[item.nutrienteid],
                        'nome': item.nome
                    }
                }
            })
            if (error) {
                setErrorMessage("Preencha todos os campos")
                setOpen(true)
            } else {
                await createDiagnostico(doenca.doencaid, nutrientesData, userId).then(response => {
                    localStorage.setItem('doenca', JSON.stringify(doencaData))
                    localStorage.setItem('nutrientes', JSON.stringify(nutrientesData))
                    navigate(path, { replace: true })
                }).catch(error => {
                    console.log(error)
                    setErrorMessage("Erro ao cadastrar diagnostico")
                    setOpen(true)
                })
            }
        } else {
            localStorage.removeItem('doenca')
            localStorage.removeItem('nutrientes')
            navigate(path, { replace: true })
        }


    }

    const loadNutrientes = async (id) => {
        await getNutrientes(id)
            .then(response => {
                console.log(response)
                setNutrientesList(response)
            })
            .catch(function (error) {
                console.log(error)
            });
    }

    const loadDoencas = async () => {
        await getDoencas()
            .then(response => {
                console.log(response)
                setDoeancasList(response)
            })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <div className='cadastro'>
            <div className='cadastro__header'>
                <img src={logo} alt='' className='login__logo' />
            </div>

            {
                page == 1 ?
                    <div>
                        <div className='cadastro__formEmail'>
                            <TextField fullWidth onChange={(event) => handleChange(event.target.value, setEmail)} id="outlined-basic" label="Email" variant="outlined" className='login__emailField' />
                        </div>

                        <div className='cadastro__formPass'>
                            <TextField fullWidth onChange={(event) => handleChange(event.target.value, setPassword)} id="outlined-password-input" label="Senha" variant="outlined" className='login__passField' type="password" autoComplete="current-password" />
                        </div>

                        <div className='cadastro__formPass'>
                            <TextField fullWidth onChange={(event) => handleChange(event.target.value, setNome)} id="outlined-basic" label="Nome" variant="outlined" className='login__emailField' />
                        </div>

                        <div className='cadastro__formPass'>
                            <TextField fullWidth onChange={(event) => handleChange(event.target.value, setSobrenome)} id="outlined-basic" label="Sobrenome" variant="outlined" className='login__emailField' />
                        </div>

                        <div style={{ marginTop: 10, marginLeft: '10%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileDatePicker
                                    label="Data de Nascimento"
                                    inputFormat="DD/MM/YYYY"
                                    value={data}
                                    onChange={handleChangeDate}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className='cadastro__formPass'>
                            <TextField
                                id="outlined-number"
                                label="Altura (m)"
                                type="number"
                                fullWidth
                                onChange={(event) => handleChange(event.target.value, setAltura)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className='cadastro__formPass'>
                            <TextField
                                id="outlined-number"
                                label="Peso (kg)"
                                type="number"
                                fullWidth
                                onChange={(event) => handleChange(event.target.value, setPeso)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </div>
                    </div>
                    :
                    <div className='cadastro__formDoenca'>
                        <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120, maxWidth: 280 }}>
                            <InputLabel id="demo-simple-select-standard-label">Diagnóstico</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={doenca}
                                onChange={handleChangeSelect}
                                label="Doença"
                                fullWidth
                            >
                                {
                                    doeancasList.map(function (item, i) {
                                        return (
                                            <MenuItem value={item}>
                                                <em>{item.nome}</em>
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        {
                            doenca.descricao != undefined &&
                            <div onClick={fullDescription} style={{ fontSize: 12, marginTop: -10 }}> {viewDescription ? <p>{description}</p> : <p>{description.substring(0, 103)}... <br></br> <b>ver mais</b></p>}</div>
                        }
                        {
                            JSON.stringify(doenca) != '{}' &&

                            <div>
                                <h4 style={{ marginBottom: -10 }}>Nutrientes Controlados:</h4>
                                {
                                    nutrientesList.map(function (item, i) {
                                        return (
                                            item.nome == 'Proteína' ?
                                                <div>
                                                    <h5>{item.nome}</h5>
                                                    <TextField id={item.nutrienteid} fullWidth onChange={(event) => handleChangeRecomendacao(event.target.value, item)} label="Recomendação diária" type="number" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 260 }} />g
                                                </div>
                                                :
                                                <div>
                                                    <h5>{item.nome}</h5>
                                                    <TextField id={item.nutrienteid} fullWidth onChange={(event) => handleChangeRecomendacao(event.target.value, item)} label="Recomendação diária" type="number" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 260 }} />mg
                                                </div>
                                        )
                                    })
                                }
                                <Alert severity="info">Não sabe? Tudo bem, esta informação é opcional! Você pode checar com seu nutricionista ou médico e incluí-la posteriormente</Alert>

                            </div>
                        }
                    </div>
            }

            <div style={{ width: '100vw' }}>
                {
                    page == 1 ?
                        <div className='cadastro__cardLogin' onClick={() => nextPage(2)}>
                            Continuar
                        </div>
                        :
                        <div>
                            <div className='cadastro__cardLogin' onClick={() => nextPage(1)}>
                                Voltar
                            </div>
                            <div className='cadastro__cardLogin' onClick={() => onClickSignup(`/`)}>
                                Criar Conta
                            </div>
                        </div>
                }
            </div>

            <div style={{ width: '100vw' }}>
                <div className='cadastro__cardSignup' onClick={() => onClickLogin(`/login`)}>
                    Fazer Login
                </div>
            </div>

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
            </Snackbar>

            <div className='cadastro__background'>
                <img src={background} alt='' className='cadastro__backgroundImage' />
            </div>

        </div>
    )
}

export default Cadastro